import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import appConstants from "../../../../../../appConstants";
import CheckboxRenderer from "../../../components/CheckboxRenderer";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  }

  static getTotalBills(params) {
    return params.data.bills?.length ?? 0;
  }

  static isChecked(params){
    return {
      checked: params.data.isSelected,
      isIntermediate: params.data.isIntermediate,
    };
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ReturnsGrid,
      keyColumn: "id",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      rowClassRules: {
        "ag-row-selected": (params) => params.data.isSelected,
      },
      columns: [
        {
          headerName: "",
          valueGetter: GridConfig.isChecked,
          colId: "batchCheckbox",
          cellRenderer: CheckboxRenderer,
          minWidth: appConstants.columnWidth.W_62,
          maxWidth: appConstants.columnWidth.W_62,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Trailer #",
          field: "trailerNumber",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "SCAC Code",
          headerTooltip: "SCAC Code",
          field: "trailerScac",
          hide: true,
          filter: MultiSelectFilter,
          width: appConstants.columnWidth.W_120,
          minWidth: appConstants.columnWidth.W_120,
          cellClass: "gridCell-leftAlign",
        },
        {
          headerName: "Manifest",
          field: "manifestNumber",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Curr Term",
          field: "currentTerminal",
          headerTooltip: "Current Terminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Next Term",
          field: "nextTerminal",
          headerTooltip: "Next Terminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Dest Term",
          field: "destinationTerminal",
          headerTooltip: "Destination Terminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Orig Term",
          field: "originTerminal",
          headerTooltip: "Origin Terminal",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Current Status",
          field: "currentStatus",
          headerTooltip: "Current Status",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Est ETA",
          field: "estimatedArrivalTime",
          headerTooltip: "Estimated Arrival Time",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Bills Due Today",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
          valueGetter: GridConfig.getTotalBills,
          colId: "totalBills",
        },
        {
          headerName: "Ttl Trlr Bills",
          headerTooltip: "Total Trailer Bills",
          field: "", // Update this when API for Trap Data is ready
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
      ],
    };
  }
}
